import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Prestataire from '../Entity/Prestataire'

/**
* Class PrestataireList
* PrestataireList view component
**/
class PrestataireList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Prestataire;

    // Filter list
    const filters = [{
      title: "Nom du prestataire",
      type: "text",
      name: "libelle",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes prestataires</h2>
        <GridFilter title="Filtrer les prestataires" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Prestataires" ref={"grid" + objectClass.name} path="prestataires" objectPath="prestataires" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + Prestataire.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["grid" + Prestataire.name];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + Prestataire.name];
    grid.clearFilters();
  }

}
export default PrestataireList;



// WEBPACK FOOTER //
// ./src/views/Search/PrestataireList.js